import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: 'Ali moram vozilo prodati, če ponudba ni ustrezna?',
  answer: 'Ne, nobene obveznosti ni. Vozila niste dolžni prodati. Ko prejmete ponudbe, se sami odločite, ali vam katera ustreza. Postopek lahko kadarkoli prekinete brez stroškov.'
}, {
  question: 'Kaj če ponujena cena ni dovolj visoka?',
  answer: 'Če ponudbe ne ustrezajo vašim pričakovanjem, lahko prodajo preprosto zavrnete. Naš cilj je doseči najboljšo možno ceno za vaše vozilo, vendar je končna odločitev vedno vaša.'
}, {
  question: 'Ali mi pomagate pri dokumentaciji in prenosu lastništva?',
  answer: 'Da, naša ekipa vam pomaga pri celotnem postopku. Poskrbimo za vso potrebno dokumentacijo, prenos lastništva in vse administrativne formalnosti. Vi samo podpišete, ostalo uredimo mi.'
}, {
  question: 'Koliko časa traja celoten postopek?',
  answer: 'Po oddaji podatkov običajno prejmete prve ponudbe v 2-3 dneh. Celoten postopek od oddaje povpraševanja do prodaje traja v povprečju 10-14 dni, odvisno od vozila in ponudb.'
}, {
  question: 'Ali moram organizirati oglede vozila?',
  answer: 'Ne, vi ne organizirate ogledov. Mi poskrbimo za predstavitev vozila kupcem. Če je potreben fizičen ogled, ga koordiniramo mi in vas obvestimo o terminu.'
}, {
  question: 'Kako poteka plačilo in kdaj prejmem denar?',
  answer: 'Plačilo poteka varno preko bančnega nakazila. Denar prejmete na vaš račun takoj po uspešnem prenosu lastništva in prevzemu vozila s strani kupca. Celoten proces je transparenten in varen.'
}, {
  question: 'Ali lahko spremljam, kako poteka prodaja mojega vozila?',
  answer: 'Da, ves čas ste obveščeni o napredku. Obveščamo vas o prejetih ponudbah, zanimanju kupcev in vseh pomembnih korakih. Vedno veste, kaj se dogaja z vašim vozilom.'
}, {
  question: 'Ali so kakšni skriti stroški?',
  answer: 'Ne, pri nas ni skritih stroškov. Oddaja vozila in cenitev sta brezplačni. Provizijo plačate le v primeru uspešne prodaje, in sicer je ta jasno določena in transparentna.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="py-16 md:py-24 bg-white" data-id="element-46">
      <div className="container mx-auto px-4" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-49">
            Pogosta vprašanja
          </h2>
          <p className="text-lg text-slate-600" data-id="element-50">
            Odgovori na najpogostejša vprašanja o prodaji vozila
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-50 transition-colors" data-id="element-53">
                <span className="font-semibold text-slate-900 pr-4" data-id="element-54">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus className="w-5 h-5 text-[#1EB6E8] flex-shrink-0" data-id="element-55" /> : <Plus className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-56" />}
              </button>
              <AnimatePresence data-id="element-57">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-58">
                    <div className="px-6 pb-6 text-slate-600 leading-relaxed" data-id="element-59">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}